<template>
    <TaskCustomFieldList />
</template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import TaskCustomFieldList from "../../components/TaskCustomFields/TaskCustomFieldList.vue";
  
  export default defineComponent({
    name: "TaskCustomFieldsPage",
    components: {
      TaskCustomFieldList,
    },
  });
  </script>